<template>
	<div class="jobModule">
		<el-container style="flex-direction: column;">
			<div class="select-block">
				<div class="mapBox">
					<div class="myMap">

						<div class="showMap">
							<div class="trendLLeft">
								<div class="mapSlider crossNj">
									<span class="mapSliderLabel">滑动查看全部作业趋势</span>
									<!--<el-slider v-model="sliderVal" :min=1 :max=imgList.length @change="sliderChange" :format-tooltip="formatTooltip" show-stops></el-slider>-->
									<vue-slider class="sliderMy" ref="slider" v-model="value" tooltip="always" @change="sliderChange" :min=min :max=max :tooltip-style="tooltipStyle" :tooltip-formatter=formatTooltip :enable-cross=false>
										
										
									</vue-slider>
								</div>
								<img :src="picUrl" />
								<!-- <img v-for="(item,index in imgList)" :key="index" :src="item.screenUrl" /> -->
							</div>
							<ul class="trendRight">
								<p>日期选择</p>
								<li v-for="(item, index) in dateList" :key="index" :class="active == index ? 'active' : ''" @click="tabClick(index, item)">{{ item }}</li>
							</ul>
						</div>
					</div>

				</div>
			</div>

		</el-container>
	</div>
</template>

<script>
	import "echarts/map/js/china.js"
	import Api from "@/Serves/net-api.js";
	import Http from "@/Serves/net-http.js";
	//import { getStore, setStore } from '@/utils/storage'
	import { mapState, mapActions, mapMutations } from "vuex";
	export default {
		name: "Monitor",
		components: {},
		data() {
			return {
				sliderVal: 0,
				active: 0,
				dateList: [],
				imgList: [],
				picUrl: '',
				value: 0,
				min: 1,
				max:22,
				//修改标签样式
				tooltipStyle: {
					color: '#FFFFFF',
					width: '118px',
					height: '38px',
					background: '#0060FF',
					borderRadius: '2px',
					lineHeight:'38px'
				}
			}
		},
		beforeDestroy() {

		},
		computed: {

		},

		mounted() {
			this.getData()

		},
		methods: {
			getData() {
				var this_ = this;
				Api.doPost(
					Http.test + '/harvestProgress/findScreenshot', {},
					false,
					res => {

						this.data = res.result;
						//循环中使用
						let dateArr = []
						for(let item in this.objectOrder(this.data)) {
							dateArr.push(item)
						}
						this.dateList = dateArr.reverse()
						this.imgList = this.data[this.dateList[0]]
						this.picUrl = this.imgList[0].screenUrl
						this.max=this.imgList.length

					}
				)
			},
			//方法
			objectOrder(obj) { //排序的函数
				var newkey = Object.keys(obj).sort(); //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
				var newObj = {}; //创建一个新的对象，用于存放排好序的键值对
				for(var i = 0; i < newkey.length; i++) { //遍历newkey数组
					newObj[newkey[i]] = obj[newkey[i]]; //向新创建的对象中按照排好的顺序依次增加键值对
				}
				return newObj; //返回排好序的新对象
			},
//			进度条改变
			sliderChange(val) {
				this.currentVal = val-1;
				this.picUrl = this.imgList[this.currentVal].screenUrl
			},
			formatTooltip(val) {
let index = val==0?val:val-1;
					let data = this.imgList[index]
					return data.screenDate.slice(5, 10) + ' ' + data.screenTime;

			},
			tabClick(val, item) {
				this.$refs.slider.setValue(0)
				this.active = val;
				this.sliderVal = 1;
				this.imgList = this.data[item]
				this.max=this.imgList.length
				this.picUrl = this.imgList[0].screenUrl
			},

		}
	}
</script>

<style scoped>
	/* 设置滚动条的样式 */
	
	::-webkit-scrollbar {
		width: 3px;
	}
	/* 滚动槽 */
	
	::-webkit-scrollbar-track {
		-webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
		border-radius: 10px;
	}
	/* 滚动条滑块 */
	
	::-webkit-scrollbar-thumb {
		border-radius: 10px;
		background: #0A63C6;
		-webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
	}
	
	.tab-box {
		width: 98%;
		margin-left: 1%;
		/* margin-bottom: 10px; */
		/* margin-top: 20px; */
		/* display: flex; */
	}
	
	.sliderMy {
		width: 60% !important;
		height: 1.5vh !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/WheatHarvest/trend.vue